import {FC} from "react";
import {Button} from "../../ui-components/button.tsx";
import {Text} from "../../ui-components/text.tsx";
import Arrow from '../../assets/images/Vector.svg'
import {BottomSheet} from "../../container/ModalSheet.tsx";
import {LightButton} from "../buttons/LightButton.tsx";
import {getReferralCode, getUserBalance, shareBotLink} from "../../utils/Utils.ts";
import {Trans, useTranslation} from "react-i18next";
import {useAppDispatch} from "../../hooks/useAppDispatch.ts";
import {setShareDataTC} from "../../state/reducers/user-reducer.ts";


export const ShareModal: FC<{ isOpen: boolean, onClose: () => void }> = ({isOpen, onClose}) => {

    const balance = getUserBalance()
    const code = getReferralCode()
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const conditionPlatform = window.Telegram?.WebApp.platform === 'ios' || window.Telegram?.WebApp.platform === 'android' || window.Telegram?.WebApp.platform === 'windows' || window.Telegram?.WebApp.platform === 'macos' || window.Telegram?.WebApp.platform === 'tdesktop'

    const shareMessageFunc = () => {
        if (conditionPlatform) {
            dispatch(setShareDataTC()).then((res) => {
                console.log('popali v then: ', res)
                if(res){
                    window?.Telegram?.WebApp.shareMessage(res)
                }else{
                    console.log('share data maybe NULL: ', res)
                    shareBotLink()
                }

            }).catch((err) => {
                console.log('popali v catch: ', err)
                shareBotLink()
            })
        } else {
            console.log('ne ta platforma: ', window.Telegram?.WebApp.platform)
            shareBotLink()
        }
    }

    return (
        <BottomSheet isOpen={isOpen} onClose={onClose}>
            <div className={"w-full flex flex-col items-center gap-y-6 px-4"}>
                <div className={"w-10 h-0.5 bg-[var(--color-line)] my-2"}></div>
                <div
                    className="px-5 pr-4 py-7 rounded-lg border border-[var(--btn-border-custom)] !shadow-none">
                    <div className="flex gap-3 items-center mb-10">
                        <Arrow className={"inline-block w-[39px] h-[39px]"}/>
                        <h2 className={"text-6xl font-black font-Roboto-Condensed"}>{balance}</h2>
                    </div>
                    <Text className="!text-[15px] font-bold !text-black shareBlck">
                        <Trans
                            i18nKey="modals.shareModal.title"
                            components={{span: <span/>}}
                            values={{code: t('modals.shareModal.freeWatchers')}}
                        />
                    </Text>
                    <Text className="!text-[15px] text-[var(--color-modal-desc)] font-bold mt-6">
                        {t('modals.shareModal.desc', {code: code})}
                    </Text>
                    <div className="flex items-center gap-3 mt-4.5">
                        <div
                            className={"w-7 h-7 rounded-full flex items-center justify-center bg-[var(--default-green-color)]"}>
                            <Arrow className={"w-3 h-3"}/>
                        </div>
                        <Text className="!text-[15px] font-bold !text-black">@tex_media_bot</Text>
                    </div>
                </div>
                <p className="!text-[15px] text-left ">
                    {t('modals.shareModal.desc', {code: code})}
                </p>
                <div className="w-full flex gap-6">
                    <LightButton title={t('common.buttons.cancel')} onClick={onClose}/>
                    <Button color={"cyan"}
                            onClick={shareMessageFunc}
                            className="w-full py-[10px] rounded-lg !bg-[var(--background-btn-blue)] before:bg-transparent text-white !text-sm !leading-5">
                        {t('common.buttons.share')}
                    </Button>
                </div>
            </div>
        </BottomSheet>
    )
}
